import React from "react";
import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { TERMS_MARKDOWN } from "@/lib/termsAndConditions";

export default function TermsPage() {
  return <LegalDocumentPage markdown={TERMS_MARKDOWN} testId="terms-page" />;
}
